import Autosuggest from "react-autosuggest";
import "./Autosuggest.css";
import { css } from "./SKT";
import { useState } from "react";

export const SKTBaseAutocompleteTextField = ({
  filterSuggestions,
  getSuggestionValue,
  renderSuggestion,
  onChange,
  id,
  placeholder,
}) => {
  const [value, setValue] = useState("");
  const trampolite_onchange = (event, { newValue }) => {
    setValue(newValue);
  };

  const onSuggestionSelected = (event, { suggestion }) => {
    onChange(suggestion);
  };
  // Teach Autosuggest how to calculate suggestions for any given input value.
  const getSuggestions = (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0 ? [] : filterSuggestions(inputValue);
  };

  const inputProps = {
    className: css("form-control data"),
    id: id,
    name: id,
    type: "text",
    value: value,
    onChange: trampolite_onchange,
    placeholder,
  };

  const [suggestions, setSuggesions] = useState([]);

  const onSuggestionsFetchRequested = ({ value }) => {
    setSuggesions(getSuggestions(value));
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  const onSuggestionsClearRequested = () => {
    setSuggesions([]);
  };

  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionSelected={onSuggestionSelected}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      inputProps={inputProps}
    />
  );
};
